import { Button, ButtonProps } from '@chakra-ui/react';
import * as React from 'react';

export const RespondButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, ...props }, ref) => {
    return (
      <Button
        variant="ghost"
        colorScheme="gray"
        iconSpacing="1"
        p="2"
        ref={ref}
        {...props}
      >
        {children}
      </Button>
    );
  }
);

RespondButton.displayName = 'RespondButton';
